import api from './api';

// 홈 화면 콘텐츠 조회
export const homeApi = {
  getHomeContent: async () => {
    const response = await api.getPublic('/home');
    return response.data;
  },

  // 섹션 타이틀 변경 (관리자 전용)
  updateSectionTitle: async (type, title) => {
    const response = await api.putAuth(`/designated-reviews/${type}/title`, { title });
    return response.data;
  },
};
